import constants from './cityConstant.js'
import {isSet,getterSetter,getFormObject,source,capitalizeFirstLetter,getQueryStringValue,connectionCheck,getutmData} from './utils/common'
import {Datepicker} from './utils/datepicker'
import {getLoggedInUser,login,updateSession} from './loginService'
import {formValidator} from './services/formValidator'
import {windowWidthService} from './services/windowWidthService'
import {getCookie,setCookie} from './services/cookieService'
import {get,set} from './services/localStorageService'
import {requirementService} from './services/requirementService'
import {otpService} from './services/otpService'
import {dataService} from './services/dataService'
import {searchSuggest} from './services/recentSearchService'
import {eventTriggerQH,eventTriggeranalatyic} from './services/gtmService'
import {addEvent} from './utils/gaService';
import {GA_HDFC_OV_OTP_INIT, GA_HDFC_OV_OTP_SUBMIT, GA_QH_DHL_FORM_INIT_OTP_CLICK, GA_QH_DHL_FORM_SUBMIT_OTP_CLICK} from './constants/analytics/homeloan-events';

require('./controller/header.js')
require('./services/gaService.js')
require('./controller/citySelectController.js')
require('./controller/requirementController.js')
require('./controller/otpController.js')

gaService.addPageView('dreamhomeloan', 'RealEstate');
getLoggedInUser.then((result) => {
    if(result && result.data && result.data.user){
        getterSetter.set( 'loginData', result);
        getterSetter.set( 'loginstatus', true);
    }else{
        getterSetter.set( 'loginstatus', false);
    }
});

var cityHtml = '';

var clickedEl, form, otpNeeded, userdata, showOTPSection, emailList, mobileList, pwdNeeded, loggedInUserId, loggedin, loginStatus, replyerr, errorLabel, alertMessage, alertClass, api_state;
var userdata = {};

var requirementForm = {};
	requirementForm.submitted = false;


var loan = document.getElementById("dwloan");
var income = document.getElementById("dwincome");

loginStatus = getterSetter.get('loginstatus');
otpNeeded = false;
showOTPSection = false;
errorLabel = "";
var HomeLoanDetails = {};
for (const key of Object.keys(constants.data.topCities)) {
  cityHtml += `<li id=${constants.data.topCities[key].id} name=${constants.data.topCities[key].name}>${constants.data.topCities[key].name}</li>`
}

CityDropdown.innerHTML = cityHtml;
cityvalue.addEventListener('keyup', (event) => {
	  let all_cities = constants.data.topCities || [];
	  all_cities = all_cities.concat(constants.data.allCities);
	  let cityhtml = ''
	  let filterCity = all_cities.filter(function(city) {
		return city.name.toLowerCase().indexOf(event.target.value.toLowerCase()) >= 0;
	  });
	  filterCity.forEach(function(city, index) {
		cityhtml += `<li id=${city.id} name="${city.name}">${city.name}</li>`
	  });
	  CityDropdown.innerHTML = cityhtml;
});

CityDropdown.addEventListener('click', (event) => {
	HomeLoanDetails.cityId = event.target.id
	cityvalue.value = HomeLoanDetails.cityName = event.target.getAttribute('name')
	setCookie('prefer_city_id',HomeLoanDetails.cityId)
	setCookie('new_prefer_city',cityvalue.value)
	$('#cityvalue').parent().addClass('has_value');
	isCityEmpty()
});


function validate(obj) {
	clickedEl = obj;
	var $form = $(clickedEl.closest("form[name='requirementForm']"));
	var emailElement = $form.find(":input[name='email']");
	var mobileElement = $form.find(":input[name='mobile']");
	var nameValid = isNameEmpty();
	var mobileValid = formValidator.isMobileNoValid.call(mobileElement);
	var emailValid = formValidator.isEmailValid.call(emailElement);
	var cityValid = isCityEmpty();
	if (loan !== null) {
		var proptypePurpose = isLoanEmpty();
	} else if (income !== null) {
		var incomeValid = isIncomeEmpty();
	}

	var otpValid = isOtpValid();
	return (nameValid && mobileValid && emailValid && cityValid && otpValid);
}


//HOME LOAN OTP JS Begin...
function buildOtpPayloadHomeLoan() {
	return {
		sellerEmail: form.email,
		sellerMobile: form.mobile,
		sellerName: form.name,
		userdata: userdata,
		page: "REPLY"
	};
}

function setAlert() {
	var $alertbox = $('.alertmsgbox');
	if (alertMessage)
		$alertbox.removeClass('hide').find('.otpalert').addClass(alertClass).find('span').text(alertMessage);
	else
		$alertbox.addClass('hide').find('.otpalert').removeAttr('class').addClass('otpalert').find('span').text('');
}

function submitReply() {
	if (api_state == "Loading") {
		return false;
	}
	alertMessage = '';
	setAlert();
	requirementService.addHomeLoanRequirement(buildPayload());
	gtmHomeLoanEvent(gtmsubmitData());
	replyerr = false;
	var gtmData = {
		'phone': form.mobile || '',
		'emailId': form.email || ''
	};
	set("autofill_contactname", requirementForm.name);
	set("autofill_email", form.email);
	set("autofill_no", form.mobile);
	$("#homeLoanModal").modal();

	// Analytics
	addEvent(GA_HDFC_OV_OTP_SUBMIT.CATEGORY, GA_HDFC_OV_OTP_SUBMIT.ACTION, GA_HDFC_OV_OTP_SUBMIT.LABEL);
	addEvent(GA_QH_DHL_FORM_SUBMIT_OTP_CLICK.CATEGORY, GA_QH_DHL_FORM_SUBMIT_OTP_CLICK.ACTION, GA_QH_DHL_FORM_SUBMIT_OTP_CLICK.LABEL);
}

function handleApiErr() {
	var otpData = otpService.getOtpVariable();
	if (errorLabel == 'MOBILE_ALREADY_REGISTERED') {
		if (otpData.showVerifiedSuccessSection) {
			submitReply();
		}
	} else if (errorLabel == 'EMAIL_ALREADY_REGISTERED') {
		submitReply();
	} else {
		if (errorLabel == 'EXISTING_USER_EMAIL_VERIFIED_LOGIN_NEEDED') {
			var jsonData = {
				"numEmail": form.email,
				"password": form.password,
				"otpCheck": 0
			};
		} else {
			if (form.pwdCheck) {
				var jsonData = {
					"numEmail": form.mobile,
					"password": form.password,
					"otpCheck": 0
				};
			} else {
				var jsonData = {
                    "GreetingName": form.mobile,
                    "password": '',
                    "otpRequest": 1,
                    "otpNumber" : otpData.otpNumber,
                    "otpId": otpData.otpId,
                    "page": 'REPLY',
                    "source":source()
                };
			}
		}
		submitReplyAfterLogin(jsonData);
	}
}

var homeloanResendOtp = document.getElementById('homeloanResendOtp');
if (homeloanResendOtp) {
	homeloanResendOtp.addEventListener('click', function (event) {
		var $otpWrapper = $('.otpSubmitForm');
		$otpWrapper.find('.error-container').addClass('hide');
	});
}

function submitReplyAfterLogin(jsonData) {
	// TODO : submitReply after login process
	// submitReply();
	var emailMatchInAcc, mobileMatchInAcc;
	login(jsonData).then((result) => {
		if (result.error == false && result.status == 'AUTH_SUCCESS') {
			$(document).trigger("loginEvent", result.data);
			userdata = result.data.user;
			userdata.errorLabel = errorLabel;
			loggedInUserId = result.data.id;
			loggedin = true;
			loginStatus = true;
			PUB_SUB.emit('do_login', {name: setLoginName(userdata)});
			if ("userEmail" in result.data.user) {
				emailList = result.data.user.userEmail;
				for (var i = 0; i < emailList.length; i++) {
					if (form.email == emailList[i].emailId) {
						form.email = emailList[i].emailId;
						emailMatchInAcc = true;
					}
				}
			}
			if (!emailMatchInAcc) {
				form.email = emailList.length > 0 ? emailList[0].emailId : form.email;
			}

			if ("userMobile" in result.data.user) {
				mobileList = result.data.user.userMobile;
				if(isSet(mobileList)) {
					for (var i = 0; i < mobileList.length; i++) {
						if (form.mobile == mobileList[i].mobileNumber) {
							form.mobile = mobileList[i].mobileNumber;
							mobileMatchInAcc = true;
						}
					}
				}
			}

			if (!mobileMatchInAcc) {
				form.mobile = isSet(mobileList) && mobileList.length > 0 ? mobileList[0].mobileNumber : form.mobile;
			}

			submitReply();

		}
		else {
			alertMessage = "Invalid OTP";
			alertClass = 'alert-danger';
			setAlert();
		}
	});
}

function setData(data) {
	if (data.email) {
		requirementForm.email = data.email;
	}
	if (data.mobile) {
		requirementForm.mobile = data.mobile;
	}
	if (data.nickname) {
		requirementForm.name = data.nickname;
	}
}

function setLoginName(user){
	if(user.firstName){
		return user.firstName;
	}else if(user.email){
		return user.email.substring(0, user.email.indexOf("@"));
	}else{
		return '';
	}
}

function buildPayload(){
	var leadpayload ={
		'userName':$('#dwfname').val(),
		'emailId':$('#dwemail').val(),
		'phoneNo':$('#dwmobile').val(),
		'cityId':HomeLoanDetails.cityId,
		'cityIdB':$('#cityvalue').val(),
		'category':$('.property').val(),
		'monthlyIncome':$('#dwincome').val(),
		'loanAmount':$('#dwloan').val(),
		'employmentStatus' : $('.employment_status').val(),
		'userId':loggedInUserId,
		'postedBy':'self',
		"leadTag":"DREAM_HOME_LOAN",
		"channel":windowWidthService.channel,
		"verticalSource":"QUIKRHOMES",
		"leadType":"HOME LOAN",
		"termSource":"QHOMES"
	}
	return leadpayload;
}


function gtmsubmitData(){
	var gtmPayload ={
		'event':"contact_DHL_success",
		'mobile': $('#dwmobile').val(),
		'email': $('#dwemail').val(),
		'Monthlyincome':$('#dwincome').val(),
		'Loanamount':$('#dwloan').val()
	}

	var utmResult = getutmData();
	gtmPayload['utm_campaign'] = utmResult['utm_campaign'];
	gtmPayload['utm_medium'] = utmResult['utm_medium'];
	gtmPayload['utm_source'] = utmResult['utm_source'];
	gtmPayload['user_db_id'] = getCookie('__u');

	return gtmPayload;
}


window.submitLoanData = function(obj) {
	var clickedElement = obj;

	if ($('#otpMsg').hasClass('hide')) {
		$('#otpMsg').removeClass('hide');
	}
	$('.otpalert').find('span').text('');

	if (!validate(obj)) {
			return false;
		}

	if (!requirementForm.submitted)
		requirementForm.submitted = true;

	if(!loginStatus){
		form = getFormObject(clickedElement.closest("form[name='requirementForm']"));
		form.name = form.name ? form.name : requirementForm.name;
		form.email = form.email ? form.email : requirementForm.email;
		form.mobile = form.mobile ? form.mobile : requirementForm.mobile;
		getterSetter.set('enquiry_email',form.email);
		getterSetter.set('enquiry_phone',form.mobile);
	}

	if(!loginStatus){
		if(isSet(otpService.getOtpVariable().otpNumber) && isSet(otpService.getOtpVariable().otpId)){
			handleApiErr();
		} else {
			otpController.init.call(clickedElement, buildOtpPayloadHomeLoan());
			otpNeeded = true;
			$("#mobileSection").addClass('wdown');
			$("#otpNeeded").addClass('otpShow');
			$("#pap_otp").focus();
			pwdNeeded = false;
			$("#submitHomeLoan").css({"display": "none"});
			$("#loginSubmitHomeLoan").css({"display": "block"});

			// Analytics
			addEvent(GA_HDFC_OV_OTP_INIT.CATEGORY, GA_HDFC_OV_OTP_INIT.ACTION, GA_HDFC_OV_OTP_INIT.LABEL);
			addEvent(GA_QH_DHL_FORM_INIT_OTP_CLICK.CATEGORY, GA_QH_DHL_FORM_INIT_OTP_CLICK.ACTION, GA_QH_DHL_FORM_INIT_OTP_CLICK.LABEL);
		}
	} else {
		if (!replyerr) {
			submitReply();
			$("#submitHomeLoan").css({"display": "none"});
			$("#loginSubmitHomeLoan").css({"display": "block"});
		} else {
			handleApiErr();
		}
	}
}

var isNameEmpty = function () {
    var name = $("#dwfname").val();
    var valid = false;
    var $nameWrapper = $('#dwfname').closest('.nameWrapper');
    if(!name){
        $nameWrapper.find('.error-container').removeClass('hide');
        valid = false;
    }
    else{
        $nameWrapper.find('.error-container').addClass('hide');
        valid = true;
    }
    return valid;
};

var isOtpValid = function () {
    var otpval = $("#pap_otp").val();
    var valid = true;
	var $otpWrapper = $('#pap_otp');
	if (otpNeeded && otpval === '') {
		otpController.setOtpErrorClass('OTP is required');
		valid = false
	}
    else if(otpNeeded && otpval.length < 4){
    	var $alertbox = $('.alertmsgbox');
    	$alertbox.addClass('hide').find('.otpalert').removeAttr('class').addClass('otpalert').find('span').text('');
        $otpWrapper.find('.error-container').removeClass('hide');
        valid = false;
    }
    else{
    	$otpWrapper.find('.error-container').addClass('hide');
        valid = true;
    }
    return valid;
};

var isIncomeEmpty = function (event) {
	var income = $("#dwincome").val();

    var valid = false;
    var $incomeWrapper = $("#dwincome").closest('.incomeWrapper');
    $("#txtIncome").addClass('hide');
    if(!income){
        $incomeWrapper.find('.error-container').removeClass('hide');
        valid = false;
    }
    else{
    	$("#txtIncome").html(getMoneyFormat(income));
    	$("#txtIncome").removeClass('hide');
        $incomeWrapper.find('.error-container').addClass('hide');
        valid = true;
    }
    return valid;
};

var isLoanEmpty = function () {
    var loan = $("#dwloan").val();
    var valid = false;
    var $loanWrapper = $("#dwloan").closest('.loanWrapper');
    $("#txtLoan").addClass('hide');
    if(!loan){
    	$loanWrapper.find('.error-container').removeClass('hide');
        valid = false;
    }
    else{
    	$("#txtLoan").html(getMoneyFormat(loan));
    	$("#txtLoan").removeClass('hide');
        $loanWrapper.find('.error-container').addClass('hide');
        valid = true;
    }
    return valid;
};

var isCityEmpty = function () {
    var city = $("#cityvalue").val();
    var valid = false;
    var $cityWrapper = $("#cityvalue").closest('.cityWrapper');
    if(!city){
        $cityWrapper.find('.error-container').removeClass('hide');
        valid = false;
    }
    else{
        $cityWrapper.find('.error-container').addClass('hide');
        valid = true;
    }
    return valid;
};

var gtmHomeLoanEvent = function (data) {
    if(connectionCheck()){
        eventTriggerQH(data);
    } else {
        eventTriggeranalatyic(data);
    }
}

function getMoneyFormat(money) {
    var numberRegex = /^[+-]?\d+(\.\d+)?([eE][+-]?\d+)?$/;
    if (numberRegex.test(money)) {
        var lCr = money / 1E12;
        if (lCr >= 1) return Number(lCr).toFixed(2) + " L Cr";
        var thCr = money / 1E10;
        if (thCr >= 1) return Number(thCr).toFixed(2) + " Th Cr";
        var cr = money / 1E7;
        if (cr >= 1) return Number(cr).toFixed(2) + " Cr";
        var lac = money / 1E5;
        if (lac >= 1) return Number(lac).toFixed(2) + " Lakhs";
        var th = money / 1E3;
        if (th >= 1) return Number(th).toFixed(1) + " Thousand";
        return Number(money)
    } else return money
}

function numberInputeOnly(event) {
	let charCode = (event.which) ? event.which : event.keyCode;

	let amt = event.target.value ? event.target.value : 0;
	let isMaxValue = (amt) ? (((amt) / 1E16) >= 1) : false;
	let isValid2DecimalNum = true;

	if (amt > -1) {
		amt = amt.toString();
		let valSplitArr = amt.split('.');
		if (valSplitArr.length < 2) {
			isValid2DecimalNum = true;
		} else if (valSplitArr.length === 2) {
			isValid2DecimalNum = valSplitArr[1].length <= 2 ? true : false;
		} else {
			isValid2DecimalNum = false;
		}
	}

	if ((charCode != 46 && charCode != 37 && charCode != 39 && charCode != 190) && charCode > 31 
	&& (charCode < 48 || charCode > 57)) {
		event.preventDefault();
	}

	if (isMaxValue && (charCode != 8 && charCode != 46 && charCode != 37 && charCode != 39 && charCode != 190)) {
		event.preventDefault();
	}

	if (!isValid2DecimalNum && (charCode != 8 && charCode != 46 && charCode != 37 && charCode != 39)) {
		event.preventDefault();
	}

	return true;
}

$(function () {
	searchSuggest();
	let name = getQueryStringValue("name");
	let mobile = getQueryStringValue("mobile");
	let email = getQueryStringValue("email");
	(name !== '') ? $("#dwfname").val(name): $("#dwname").val(get('autofill_contactname'));
	(mobile !== '') ? $("#dwemail").val(email): $("#dwemail").val(get('autofill_email'));
	(email !== '') ? $("#dwmobile").val(mobile): $("#dwmobile").val(get('autofill_no'));
	
	HomeLoanDetails.cityId = getCookie('prefer_city_id') || '';
	var cookie_city = (getCookie('new_prefer_city') === 'www') ? 'All India' : getCookie('new_prefer_city');
	$("#cityvalue").val(capitalizeFirstLetter(cookie_city));

	var gtmData = {
		'event':'contact_DHL_initiate'
	};
	var utmResult = getutmData();
	gtmData['utm_campaign'] = utmResult['utm_campaign'];
	gtmData['utm_medium'] = utmResult['utm_medium'];
	gtmData['utm_source'] = utmResult['utm_source'];
	gtmData['user_db_id'] = getCookie('__u');
	gtmHomeLoanEvent(gtmData);
	
		if($('#dwfname').val().length){
			$('#dwfname').parent().addClass('open');
		}

		if($('#dwemail').val().length){
			$('#dwemail').parent().addClass('open');
		}
	
		if($('#dwmobile').val().length){
			$('#dwmobile').parent().addClass('open');
		}
	
		if($('#cityvalue').val().length){
			$('#cityvalue').parent().addClass('has_value');
		}
});

document.getElementById('dwincome').addEventListener('keydown', numberInputeOnly)
document.getElementById('dwloan').addEventListener('keydown', numberInputeOnly)

$(document).on('keyup change blur', 'div.input-custom-label.nameWrapper input', isNameEmpty);
$(document).on('keyup change load', 'div.input-custom-label.incomeWrapper input', isIncomeEmpty);
$(document).on('keyup change load', 'div.input-custom-label.loanWrapper input', isLoanEmpty);
$(document).on('keyup change blur', 'div.input-custom-label.cityWrapper input', isCityEmpty);
$(document).on('keyup change', "input[id='pap_otp']", isOtpValid);

$(document).on('blur', '#cityvalue', function() {
	if($('#cityvalue').val().length){
		$('#cityvalue').parent().addClass('has_value');
	} else {
		$('#cityvalue').parent().removeClass('has_value');
	}
});

$(document).on("focus", ".hlinput", function(e){
	var focusInput = $(this).val();
	var $floatingLabel = $(this).closest('.input-custom-dropdown');
	if(!$(this).hasClass("open")) {
		$floatingLabel.addClass('open');
	} else {
		$floatingLabel.removeClass('open');
	}
});

$(document).on("keyup blur", ".hlinput", function(e){
	var focusInput = $(this).val();
	if(focusInput.length > 0) {
		$(this).closest('.input-custom-dropdown').addClass('open');
	} else {
		$(this).closest('.input-custom-dropdown').removeClass('open');
	}
});